<template>
  <v-row justify="center">
    <v-dialog v-model="openModal" persistent max-width="600px">
      <v-card>
        <v-card-title>
          <span class="text-h5">Data Karyawan</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" sm="6" md="4">
                <v-text-field
                  label="Nama (wajib)"
                  autofocus
                  required
                  v-model="formData.nama"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <v-text-field
                  label="Status (wajib)"
                  required
                  v-model="formData.status"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <v-text-field
                  label="Telp"
                  required
                  v-model="formData.telp"
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-text-field
                  label="Alamat"
                  required
                  v-model="formData.alamat"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="6">
                <v-text-field
                  label="Keterangan"
                  required
                  v-model="formData.ket"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="6">
                <v-select
                  :items="['Y', 'N']"
                  label="Aktif (wajib)"
                  required
                  v-model="formData.is_active"
                ></v-select>
              </v-col>
              <v-col cols="12" sm="6">
                <v-select
                  :items="[{text:'Pontianak',value:'pontianak'},{text:'Jakarta',value:'jakarta'}]"
                  label="Lokasi"
                  clearable
                  v-model="formData.lokasi"
                ></v-select>
              </v-col>
              <v-col cols="12" sm="6">
                <v-text-field
                  label="Username"
                  v-model="formData.username"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6">
                <v-text-field
                  label="Password"
                  type="password"
                  v-model="formData.password"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6">
                <v-menu
                  ref="menu1"
                  v-model="menu1"
                  :close-on-content-click="true"
                  transition="scale-transition"
                  offset-y
                  max-width="290px"
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      label="Tanggal Masuk"
                      persistent-hint
                      prepend-icon="mdi-calendar"
                      v-bind="attrs"
                      v-on="on"
                      v-model="formData.tgl_masuk"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="formData.tgl_masuk"
                    no-title
                    @input="menu1 = false"
                  ></v-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="12">
                <div class="text-subtitle-2 mb-2">Hak Akses Menu</div>
                <v-treeview
                  v-model="formData.permissions"
                  :items="menuItems"
                  selectable
                  selected-color="primary"
                  item-key="to"
                  item-text="title"
                  open-all
                  dense
                ></v-treeview>
              </v-col>
              <v-col cols="12" sm="6">
                <v-menu
                  ref="menu2"
                  v-model="menu2"
                  :close-on-content-click="true"
                  transition="scale-transition"
                  offset-y
                  max-width="290px"
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      label="Tanggal Keluar"
                      persistent-hint
                      prepend-icon="mdi-calendar"
                      v-bind="attrs"
                      v-on="on"
                      v-model="formData.tgl_keluar"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="formData.tgl_keluar"
                    no-title
                    @input="menu2 = false"
                  ></v-date-picker>
                </v-menu>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            text
            :disabled="loading"
            tabindex="-1"
            @click="
              $emit('close-modal');
              resetFormData();
            "
          >
            Close
          </v-btn>
          <v-btn
            color="blue darken-1"
            :loading="loading"
            text
            @click="createData"
          >
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import axios from "axios";
import store from "@/store";

export default {
  name: "CreateModal",
  props: ["openModal"],
  data() {
    return {
      formData: {
        nama: "",
        status: "",
        alamat: "",
        telp: "",
        ket: "",
        is_active: "Y",
        lokasi: "",
        tgl_masuk: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
          .toISOString()
          .substr(0, 10),
        tgl_keluar: "",
        username: "",
        password: "",
        permissions: []
      },
      menu1: false,
      menu2: false,
      loading: false
    };
  },
  computed: {
    menuItems() {
      return store.state.app.items
        .map(i => {
          const item = {
            to: i.to,
            title: i.title
          };
          if (i.items && i.items.length) {
            item.children = i.items.map(s => ({ to: s.to, title: s.title }));
          }

          return item;
        });
    },
    validPermissionPaths() {
      return collectPermissionPaths(store.state.app.items);
    }
  },
  methods: {
    async createData() {
      this.loading = true;
      const payload = {
        ...this.formData,
        permissions: normalizeSelectedPermissions(
          this.formData.permissions,
          this.validPermissionPaths
        )
      };

      await axios
        .post(`karyawan`, payload)
        .then(res => {
          this.loading = false;
          this.$emit("close-modal");

          this.resetFormData();
        })
        .catch(err => {
          this.loading = false;

          alert(err.response?.data?.message || "Gagal menyimpan data karyawan");
        });
    },
    resetFormData() {
      this.formData.nama = "";
      this.formData.status = "";
      this.formData.alamat = "";
      this.formData.telp = "";
      this.formData.ket = "";
      this.formData.is_active = "Y";
      this.formData.lokasi = "";
      this.formData.tgl_masuk = new Date(
        Date.now() - new Date().getTimezoneOffset() * 60000
      )
        .toISOString()
        .substr(0, 10);
      this.formData.tgl_keluar = "";
      this.formData.username = "";
      this.formData.password = "";
      this.formData.permissions = [];
    }
  }
};

function normalizePath(path) {
  const clean = String(path || "").replace(/\/$/, "");
  return clean || "/";
}

function collectPermissionPaths(items) {
  const paths = [];

  (items || []).forEach(item => {
    if (item.items && item.items.length) {
      item.items.forEach(child => paths.push(normalizePath(child.to)));
      return;
    }

    paths.push(normalizePath(item.to));
  });

  return [...new Set(paths)];
}

function normalizeSelectedPermissions(selected, validPaths) {
  const valid = new Set(validPaths);

  return (selected || [])
    .map(normalizePath)
    .filter(path => valid.has(path));
}
</script>
